export class WindowRouter {
    public assign(url: string) {
        return window.location.assign(url);
    }
}
